import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';

@Component({
  selector: 'to-carrier',
  templateUrl: './carrier.html',
  styleUrls: ['./carrier.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarrierComponent {
  @Input() carrier: 'AA' | 'US' = 'AA';
  @Input() size: string;
}

@NgModule({
  declarations: [CarrierComponent],
  exports: [CarrierComponent],
  imports: [CommonModule],
})
export class CarrierModule { }
